import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type NeedsSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_NEEDS_SORT_OPTION: NeedsSortOption = "newest";

const OPTIONS: SortOption<NeedsSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function needsSortOptionLabel(option: NeedsSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function needsSortOptionToParams(option: NeedsSortOption): {
  sortBy: "createdAt" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortNeedsPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: NeedsSortOption;
  setSortOption: (option: NeedsSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Needs"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
